import React, {useState} from 'react';
import {Button, Form, Row} from 'antd';
import {DiazarFormInput} from '../../Components/Form/DiazarFormInput';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {ModalResetPasswordSuccess} from './ModalResetPasswordSuccess';
import {CompanyInputForm} from '../../Components/Form/CompanyInputForm';
import {useParameterizedQuery} from 'react-fetching-library';
import {resetPassword} from '../../Actions/Users/UsersActions';
import {MessageResponse} from '../../Actions/Domain';
import {useNavigate} from 'react-router-dom';

export const DiazarPasswordResetForm: React.FunctionComponent = (_props) => {
    const [email, setEmail] = useState<string>('');
    const [isValidEmail, setIsValidEmail] = useState<boolean>(false);

    const [company, setCompany] = useState<string>('');
    const [isValidCompany, setIsValidCompany] = useState<boolean>(false);
    const [hasValidCompany, setHasValidCompany] = useState<boolean>(false);
    const [validCompanyErrorMessage, setValidCompanyErrorMessage] = useState<string>();

    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string|undefined>(undefined);
    const [successMessage, setSuccessMessage] = useState<string|undefined>(undefined);

    const [validCompany, setValidCompany] = useState<string>('');

    const resetPassAction = useParameterizedQuery(resetPassword);

    const navigate = useNavigate();


    const handleLogin = React.useCallback( async ()=>{
        const data = {
            email: email,
            company: company
        };

        setLoading( true );

        await resetPassAction.query( data ).then( (res) => {
            setLoading( false );
            if (res.payload && res.payload.response){
                const response:MessageResponse = res.payload;
                if( response.error['has-error'] ){
                    setErrorMessage( response.error.error );
                }else{
                    setErrorMessage( undefined );
                    setSuccessMessage( response.response );
                }
            }
        } ).catch( error => {
            setLoading( false );
            console.log( error );
        } );
    }, [company, email, resetPassAction]);

    const isValidForm = React.useMemo<boolean>( () => {
        const isLoading = ( loading !== undefined ) ? loading : false;
        return !isLoading && isValidEmail && isValidCompany;
    }, [isValidCompany, isValidEmail, loading] );


    const helperText = React.useMemo( () => {
        if ( errorMessage === undefined ){
            return null;
        }else{
            return (
                <Form.Item help={
                    <span style={{ color: 'red' }}>
                        <ExclamationCircleOutlined /> &nbsp;{errorMessage}
                    </span>
                } />
            );
        }
    }, [errorMessage] );

    const redirectPath = React.useMemo(()=>{
        const origin = sessionStorage.getItem('login-redirect');

        if (origin !== null) {
            return origin;
        }

        return '/login';
    }, []);

    return (
        <React.Fragment>
            <ModalResetPasswordSuccess message={ successMessage } />
            <div className="auth-wrapper">
                <div className="auth-inner">
                    <Form
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        autoComplete="off"
                        layout="vertical"
                        style={{textAlign: 'justify'}}
                    >
                        { helperText }
                        <CompanyInputForm
                            setIsValidCompany={ setIsValidCompany }
                            setCompany={setCompany}
                            company={company}
                            isLoadingForm={loading}
                            hasValidCompany={hasValidCompany}
                            isValidCompany={isValidCompany}
                            setValidCompanyErrorMessage={setValidCompanyErrorMessage}
                            setHasValidCompany={setHasValidCompany}
                            validCompanyErrorMessage={validCompanyErrorMessage}
                            validCompany={validCompany}
                            setValidCompany={setValidCompany}
                            refSelector="password-reset-request-email"
                        />

                        <DiazarFormInput getState={
                                            (isValid, value) => {
                                                setIsValidEmail( isValid );
                                                setEmail( value );
                                            }
                                        }
                                         id="password-reset-request-email"
                                         label='Email'
                                         isRequired
                                         helperText="Introduce el email registrado en diazar por la empresa donde quieres recuperar la contraseña"
                                         placeholder="Email de Usuario"
                                         type="email"
                                         isReadOnly={ !hasValidCompany || loading }
                                         onPressEnter={ handleLogin }
                        />

                        <Row />
                        <Form.Item className="btn-form-actions">
                            <Button
                                    onClick={ e => { e.preventDefault(); handleLogin(); }}
                                    block
                                    disabled={ !isValidForm }
                                    loading={ ( loading !== undefined ) ? loading : false }
                            >
                                Enviar
                            </Button>

                            <Button
                                type="link"
                                onClick={_ => {
                                    sessionStorage.removeItem('login-redirect');
                                    navigate(redirectPath);
                                }}
                                block
                            >
                                Ir a Login
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

/*
const [isRememberMeChecked, setIsRememberMeChecked] = useState<boolean>(false)
<FormGroup fieldId="pf-login-remember-me-id">
    <Checkbox
        id="pf-login-remember-me-id"
        label="Recordarme"
        isChecked={isRememberMeChecked}
        onChange={ (curremt, e) => { setIsRememberMeChecked(curremt) } }
    />
</FormGroup>
*/
